var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress-bar"},[_c('div',{staticClass:"progress",style:([ _vm.progressPercent < 100 ? { width: (_vm.progressPercent + "%"), background: _vm.getProgressColor() } : { width: "100%", background: '#1d8e00' } ])})])}
var staticRenderFns = []

export { render, staticRenderFns }